import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import { closeModal, removeConversationFromHistory } from '../../../../../store/chat/slice';
import { deleteConversation } from '../../../../../api/chatApi';
import { Modal, Button } from '../../../../../components/UI';
import { Text } from '../../../../../components/Typography';
import styles from './ConversationModals.module.scss';

const DeleteConversationModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { modal } = useAppSelector((state) => state.chat);
  const [isDeleting, setIsDeleting] = React.useState(false);

  const isOpen = modal?.type === 'delete';
  const conversationId = modal?.type === 'delete' ? modal.conversationId : undefined;

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleDelete = async () => {
    if (!conversationId) return;

    try {
      setIsDeleting(true);
      await deleteConversation(conversationId);
      dispatch(removeConversationFromHistory(conversationId));

      dispatch(closeModal());
    } catch (error) {
      console.error('Failed to delete conversation:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Delete conversation">
      <div className={styles.modalContent}>
        <Text size="base">
          Are you sure you want to delete this conversation? This action cannot be undone.
        </Text>
      </div>
      <div className={styles.modalActions}>
        <Button variant="secondary" onClick={handleClose} disabled={isDeleting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDelete} loading={isDeleting}>
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteConversationModal;
